import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import LuigiClient from '@luigi-project/client';
import $ from 'jquery';
import appTheme from '../../AppThemes';
window.$ = $;

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const UserPreferences = ({ userPreferencesModal }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const action = userPreferencesModal;
  let selectDefault = 'mui-card';
  let selectLight = 'mui-card';
  let selectDark = 'mui-card';

  //Open From Side nav
  window.addEventListener(
    'userPreferences',
    e => {
      setOpen(true);
    },
    false,
  );

  const controlPointSend = (msgType, data) => {
    LuigiClient.setTargetOrigin(window.location.origin);

    LuigiClient.sendCustomMessage({
      id: 'controlpoint.send',
      value: {
        id: msgType,
        value: data,
      },
    });
  };

  const defaultSelection = () => {
    selectDefault = 'light mui-card';
    $('body').removeClass('cfa-light');
    $('body').removeClass('cfa-dark');
    $('body').addClass('cfa-light');
    $('#lightSelection').removeClass('with-border');
    $('#darkSelection').removeClass('with-border');
    $('#defaultSelection').addClass('with-border');
    controlPointSend('theme.change', 'light');
    localStorage.setItem('theme', 'light');
    appTheme.theme.palette.primary.main = appTheme.pallete.light;
  };
  const lightSelection = () => {
    selectLight = 'mui-card';
    $('body').removeClass('cfa-dark');
    $('body').addClass('cfa-light');
    $('#darkSelection').removeClass('with-border');
    $('#defaultSelection').removeClass('with-border');
    $('#lightSelection').addClass('with-border');
    controlPointSend('theme.change', 'light');
    localStorage.setItem('theme', 'light');
    appTheme.theme.palette.primary.main = appTheme.pallete.light;
  };
  const darkSelection = () => {
    selectDark = 'mui-card';
    $('body').removeClass('cfa-light');
    $('body').addClass('cfa-dark');
    $('#defaultSelection').removeClass('with-border');
    $('#lightSelection').removeClass('with-border');
    $('#darkSelection').addClass('with-border');
    controlPointSend('theme.change', 'dark');
    localStorage.setItem('theme', 'dark');
    appTheme.theme.palette.primary.main = appTheme.pallete.dark;
  };

  React.useEffect(() => {
    action.current = handleOpen;
  });
  return (
    <div>
      <Modal
        className="cfa-modal"
        disableEnforceFocus
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            className="cfa-modal-title"
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            Preferences
          </Typography>
          <span className="cfa-modal-sub-title"> App Theme </span>
          <Typography
            variant="section"
            id="modal-modal-description"
            sx={{ mt: 2 }}
          >
            <div className="settings-panel-theme">
              <Card
                id="defaultSelection"
                onClick={defaultSelection}
                className={selectDefault}
              >
                <CardContent>
                  <span className="mui-card-span">Browser Default</span>
                </CardContent>
              </Card>
              <Card
                id="lightSelection"
                onClick={lightSelection}
                className={selectLight}
              >
                <CardContent>
                  <span className="mui-card-span">Light</span>
                </CardContent>
              </Card>
              <Card
                id="darkSelection"
                onClick={darkSelection}
                className={selectDark}
              >
                <CardContent>
                  <span className="mui-card-span">Dark</span>
                </CardContent>
              </Card>
            </div>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};
export default UserPreferences;
